import { Skeleton } from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import { PropsWithChildren } from "react";

interface CanvasSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const CanvasSkeleton = ({
  className,
  ...props
}: CanvasSkeletonProps) => {
  return (
    <div
      className={cn("bg-primary/10 animate-none rounded-xl", className)}
      {...props}
    />
  );
};
